import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const getScheduleSummary = () => axios.get(`${apiUrl}dashboard/ScheduleSummary`);

export const getServiceReassignment = (fromDate, toDate) => {
    const params = [];
    if (fromDate) {
        params.push(`fromDate=${fromDate}`);
    }
    if (toDate) {
        params.push(`toDate=${toDate}`);
    }
    const query = params.length ? `?${params.join("&")}` : "";
    return axios.get(`${apiUrl}Schedule/reassignments${query}`);
};

export const setServiceReassignment = (id) => axios.post(`${apiUrl}Schedule/reassignments/${id}/act`);

export const getMerchandiserDashboardNotifications = () => axios.get(`${apiUrl}Dashboard/Notifications`);

export const getMerchandiserDashboardConfirmedServices = (fromDate, toDate) => {
    const params = [];
    if (fromDate) {
        params.push(`fromDate=${fromDate}`);
    }
    if (toDate) {
        params.push(`toDate=${toDate}`);
    }
    const query = params.length ? `?${params.join("&")}` : "";
    return axios.get(`${apiUrl}Dashboard/ConfirmedServices${query}`);
};
